import { TypedDocumentNode, gql } from '@apollo/client';
import { ReactNode } from 'react';
import styled from 'styled-components';

import { Container } from '@sorare/core/src/atoms/layout/Container';
import { Vertical } from '@sorare/core/src/atoms/layout/flex';

import {
  Props as LeagueLeaguePageHeaderProps,
  LeaguePageHeader,
} from 'components/league/LeaguePageHeader';

import {
  So5LeagueLayout_so5LeaderboardContender,
  So5LeagueLayout_so5League,
} from './__generated__/index.graphql';

const Wrapper = styled(Container)`
  min-height: var(--100vh);
  padding: var(--double-unit) 0;
`;

type Props = LeagueLeaguePageHeaderProps & {
  children: ReactNode;
  so5League: So5LeagueLayout_so5League;
  so5LeaderboardContender?: So5LeagueLayout_so5LeaderboardContender;
  displayFixtureStatus?: boolean;
};
export const So5LeagueLayout = ({
  children,
  so5League,
  so5LeaderboardContender,
  displayFixtureStatus,
  onClose,
  title,
  action,
}: Props) => {
  return (
    <Wrapper>
      <Vertical gap={2} as="section">
        <LeaguePageHeader
          onClose={onClose}
          so5League={so5League}
          so5LeaderboardContender={so5LeaderboardContender}
          title={title}
          displayFixtureStatus={displayFixtureStatus}
          action={action}
        />
        <div>{children}</div>
      </Vertical>
    </Wrapper>
  );
};

So5LeagueLayout.fragments = {
  so5League: gql`
    fragment So5LeagueLayout_so5League on So5League {
      slug
      ...LeaguePageHeader_so5League
    }
    ${LeaguePageHeader.fragments.so5League}
  ` as TypedDocumentNode<So5LeagueLayout_so5League>,
  so5LeaderboardContender: gql`
    fragment So5LeagueLayout_so5LeaderboardContender on So5LeaderboardContender {
      slug
      ...LeaguePageHeader_so5LeaderboardContender
    }
    ${LeaguePageHeader.fragments.so5LeaderboardContender}
  ` as TypedDocumentNode<So5LeagueLayout_so5LeaderboardContender>,
};
